'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _renderDeclarations = require('./renderDeclarations');

var _renderDeclarations2 = _interopRequireDefault(_renderDeclarations);

var _formatting = require('../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderBaseline = function renderBaseline(name, value) {
  return (0, _ramda.compose)(_formatting.joinWithNewline, _renderDeclarations2.default)([['fontSize', value[0]], ['lineHeight', value[1]]]);
};

exports.default = renderBaseline;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/renderers/renderBaseline.js
// module id = 656
// module chunks = 168707334958949